import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { showDialog } from "@widgets/CommonDialog";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PUR_POR_REG_001_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridApiRef1 = useRef<any>(null);
    const gridApiRef2 = useRef<any>(null);
    const gridApiRef3 = useRef<any>(null);
    const gridApiRef4 = useRef<any>(null);
    const gridApiRef5 = useRef<any>(null);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [columns3, setColums3] = useState<any[]>([]);
    const [columns4, setColums4] = useState<any[]>([]);
    const [columns5, setColums5] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    const [dataSource3, setDataSource3] = useState<any[]>([]);
    const [dataSource4, setDataSource4] = useState<any[]>([]);
    const [dataSource5, setDataSource5] = useState<any[]>([]);

    const [gridFocus1, setGridFocus1] = useState(false);
    const [gridFocus2, setGridFocus2] = useState(false);
    const [gridFocus3, setGridFocus3] = useState(false);
    const [gridFocus4, setGridFocus4] = useState(false);
    const [gridFocus5, setGridFocus5] = useState(false);

    const [selectedTab, setSelectedTab] = useState<string>("1");
    const isSyncingCheckbox = useRef(false);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => {
        if (selectedTab === "1") {
          return [
            gridApiRef1.current?.getCheckedRows() || [],
            gridApiRef2.current?.getCheckedRows() || [],
          ];
        } else if (selectedTab === "2") {
          return [
            gridApiRef3.current?.getCheckedRows() || [],
            gridApiRef3.current?.getCheckedRows() || [],
          ];
        } else if (selectedTab === "3") {
          return [
            gridApiRef4.current?.getCheckedRows() || [],
            gridApiRef5.current?.getCheckedRows() || [],
          ];
        }
      },
    }));
    console.log(userInfo);
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_PUR_POR_REG_001_POP_01", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums1(rtn.grid.grid1);
          setColums2(rtn.grid.grid2);
          setColums3(rtn.grid.grid3);
          setColums4(rtn.grid.grid4);
          setColums5(rtn.grid.grid5);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      if (selectedTab === "1") {
        gridApiRef1.current.selectAndFocusRow(0);
        gridApiRef2.current.selectAndFocusRow(0);
        setGridFocus1(false);
        setGridFocus2(false);
      } else if (selectedTab === "2") {
        gridApiRef3.current.selectAndFocusRow(0);
        setGridFocus3(false);
      } else if (selectedTab === "3") {
        gridApiRef4.current.selectAndFocusRow(0);
        gridApiRef5.current.selectAndFocusRow(0);
        setGridFocus4(false);
        setGridFocus5(false);
      }
    }, [gridFocus1, gridFocus2, gridFocus3, gridFocus4, gridFocus5]);

    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_pur_por_reg_001_pop_01_02",
            params: searchRef.current.getFormdata(),
          };

          setDataSource1([]);
          setDataSource2([]);
          setDataSource3([]);
          setDataSource4([]);
          setDataSource5([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);
          setDataSource2(data[1] || []);
          setDataSource3(data[2] || []);
          setDataSource4(data[3] || []);
          setDataSource5(data[4] || []);

          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));
            setGridFocus1(true);
            setGridFocus2(true);
            setGridFocus3(true);
            setGridFocus4(true);
            setGridFocus5(true);
          }

          switch (selectedTab) {
            case "1":
              gridApiRef1.current?.selectAndFocusRow(0);
              break;
            case "2":
              gridApiRef3.current?.selectAndFocusRow(0);
              break;
            case "3":
              gridApiRef4.current?.selectAndFocusRow(0);
              break;
          }

          gridApiRef1.current.resetUpdate();
          gridApiRef2.current.resetUpdate();
          gridApiRef3.current.resetUpdate();
          gridApiRef4.current.resetUpdate();
          gridApiRef5.current.resetUpdate();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };

    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const no_app = selectedRow.no_app;
        const cd_exch = selectedRow.cd_exch;
        const rt_exch = selectedRow.rt_exch;
        gridApiRef2.current.applyFilters({
          no_app: no_app,
          cd_exch: cd_exch,
          rt_exch: rt_exch,
        });
      } else {
        return;
      }
    };

    const onFocusedRowChanged2 = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        const cd_cust = selectedRow.cd_cust;
        const cd_exch = selectedRow.cd_exch;
        const rt_exch = selectedRow.rt_exch;
        gridApiRef5.current.applyFilters({
          cd_cust: cd_cust,
          cd_exch: cd_exch,
          rt_exch: rt_exch,
        });
      } else {
        return;
      }
    };

    const onCellValueChanged = (event: any) => {
      if (!event) return;

      if (isSyncingCheckbox.current) return;

      const updatedRow = event.data;
      const updatedColumnId = event.column.getColId();

      if (updatedColumnId !== "fixCheckbox") return;

      const isChecked = updatedRow.fixCheckbox;
      const { no_app, cd_cust, cd_exch, rt_exch } = updatedRow;

      const checkedCusts = new Set<string>();

      gridApiRef2.current.api.forEachNode((node: any) => {
        if (node.data.fixCheckbox) {
          checkedCusts.add(node.data.cd_cust);
        }
      });

      gridApiRef1.current.api.forEachNode((node: any) => {
        if (node.data.fixCheckbox) {
          checkedCusts.add(node.data.cd_cust);
        }
      });

      if (checkedCusts.size > 1) {
        showDialog("alter", "서로다른 거래처를 선택하였습니다.");
        event.node.setDataValue("fixCheckbox", false);
        return;
      }

      const isParentGrid =
        gridApiRef1.current.api.getRowNode(event.node.id) !== undefined;

      isSyncingCheckbox.current = true;

      if (isParentGrid) {
        gridApiRef2.current.api.forEachNode((node: any) => {
          const child = node.data;
          if (
            child.no_app === no_app &&
            child.cd_exch === cd_exch &&
            child.rt_exch === rt_exch
          ) {
            node.setDataValue("fixCheckbox", isChecked);
          }
        });
      } else {
        const matchingChildren: any[] = [];

        gridApiRef2.current.api.forEachNode((node: any) => {
          const child = node.data;
          if (
            child.no_app === no_app &&
            child.cd_exch === cd_exch &&
            child.rt_exch === rt_exch
          ) {
            matchingChildren.push(child);
          }
        });

        const anyChecked = matchingChildren.some((row) => row.fixCheckbox);
        gridApiRef1.current.api.forEachNode((node: any) => {
          const parent = node.data;
          if (
            parent.no_app === no_app &&
            parent.cd_exch === cd_exch &&
            parent.rt_exch === rt_exch
          ) {
            node.setDataValue("fixCheckbox", anyChecked);
          }
        });
      }

      setTimeout(() => {
        isSyncingCheckbox.current = false;
      }, 0);
    };

    const onCellValueChanged2 = (event: any) => {
      if (!event) return;

      if (isSyncingCheckbox.current) return;

      const updatedRow = event.data;
      const updatedColumnId = event.column.getColId();

      if (updatedColumnId !== "fixCheckbox") return;

      const isChecked = updatedRow.fixCheckbox;
      const { cd_cust, cd_exch, rt_exch } = updatedRow;

      const checkedCusts = new Set<string>();

      gridApiRef5.current.api.forEachNode((node: any) => {
        if (node.data.fixCheckbox) {
          checkedCusts.add(node.data.cd_cust);
        }
      });

      gridApiRef4.current.api.forEachNode((node: any) => {
        if (node.data.fixCheckbox) {
          checkedCusts.add(node.data.cd_cust);
        }
      });

      if (checkedCusts.size > 1) {
        showDialog("alter", "서로다른 거래처를 선택하였습니다.");
        event.node.setDataValue("fixCheckbox", false);
        return;
      }

      const isParentGrid =
        gridApiRef4.current.api.getRowNode(event.node.id) !== undefined;

      isSyncingCheckbox.current = true;

      if (isParentGrid) {
        gridApiRef5.current.api.forEachNode((node: any) => {
          const child = node.data;
          if (
            child.cd_cust === cd_cust &&
            child.cd_exch === cd_exch &&
            child.rt_exch === rt_exch
          ) {
            node.setDataValue("fixCheckbox", isChecked);
          }
        });
      } else {
        const matchingChildren: any[] = [];

        gridApiRef5.current.api.forEachNode((node: any) => {
          const child = node.data;
          if (
            child.cd_cust === cd_cust &&
            child.cd_exch === cd_exch &&
            child.rt_exch === rt_exch
          ) {
            matchingChildren.push(child);
          }
        });

        const anyChecked = matchingChildren.some((row) => row.fixCheckbox);

        gridApiRef4.current.api.forEachNode((node: any) => {
          const parent = node.data;
          if (
            parent.cd_cust === cd_cust &&
            parent.cd_exch === cd_exch &&
            parent.rt_exch === rt_exch
          ) {
            node.setDataValue("fixCheckbox", anyChecked);
          }
        });
      }

      setTimeout(() => {
        isSyncingCheckbox.current = false;
      }, 0);
    };

    const onTabChanged = (index: string) => {
      setSelectedTab(index);
      setTimeout(() => {
        if (index === "1") gridApiRef1.current?.selectAndFocusRow(0);
        else if (index === "2") gridApiRef3.current?.selectAndFocusRow(0);
        else if (index === "3") gridApiRef4.current?.selectAndFocusRow(0);
      }, 50);
    };

    return (
      <div className="flex flex-col h-full overflow-hidden">
        <div className="flex-shrink-0">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          />
        </div>
        <div className="flex-shrink-0 text-center">
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 overflow-hidden">
          <SnTab
            titles={["품의번호별", "품목별", "거래처별"]}
            width={"100%"}
            body={[
              <div className="flex flex-col h-full space-y-1.5 overflow-hidden">
                <div className="flex-1 overflow-hidden">
                  <SnGrid
                    ref={gridApiRef1}
                    columnConfig={columns1}
                    rowData={dataSource1}
                    rowSelection="single"
                    isEditable={false}
                    enableAddRow={false}
                    ischeckboxSelection={true}
                    onFocusedRowChanged={onFocusedRowChanged}
                    onCellValueChanged={onCellValueChanged}
                  />
                </div>
                <div className="flex-1 overflow-hidden">
                  <SnGrid
                    ref={gridApiRef2}
                    columnConfig={columns2}
                    rowData={dataSource2}
                    rowSelection="multiple"
                    isEditable={false}
                    enableAddRow={false}
                    ischeckboxSelection={true}
                    onCellValueChanged={onCellValueChanged}
                  />
                </div>
              </div>,

              <div className="flex flex-col h-full overflow-hidden space-y-1.5">
                <SnGrid
                  ref={gridApiRef3}
                  columnConfig={columns3}
                  rowData={dataSource3}
                  rowSelection="multiple"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                />
              </div>,

              <div className="flex flex-col h-full space-y-1.5 overflow-hidden">
                <div className="flex-1 overflow-hidden">
                  <SnGrid
                    ref={gridApiRef4}
                    columnConfig={columns4}
                    rowData={dataSource4}
                    rowSelection="single"
                    isEditable={false}
                    enableAddRow={false}
                    ischeckboxSelection={true}
                    onFocusedRowChanged={onFocusedRowChanged2}
                    onCellValueChanged={onCellValueChanged2}
                  />
                </div>
                <div className="flex-1 overflow-hidden">
                  <SnGrid
                    ref={gridApiRef5}
                    columnConfig={columns5}
                    rowData={dataSource5}
                    rowSelection="multiple"
                    isEditable={false}
                    enableAddRow={false}
                    ischeckboxSelection={true}
                    onCellValueChanged={onCellValueChanged2}
                  />
                </div>
              </div>,
            ]}
            onTabChanged={onTabChanged}
          />
        </div>
      </div>
    );
  }
);

export default SN_PUR_POR_REG_001_POP_01;
